3<template>
    <TransitionRoot as="template" :show="show">
        <Dialog as="div" class="fixed inset-0 overflow-hidden" @close="close()">
            <div class="absolute inset-0 overflow-hidden">
                <DialogOverlay class="absolute inset-0 bg-gray-500 opacity-75"/>

                <div class="fixed inset-y-0 pl-16 max-w-full right-0 flex">
                    <TransitionChild as="template" enter="transform transition ease-in-out duration-500 sm:duration-700"
                                     enter-from="translate-x-full" enter-to="translate-x-0"
                                     leave="transform transition ease-in-out duration-500 sm:duration-700"
                                     leave-from="translate-x-0" leave-to="translate-x-full">
                        <div class="w-screen max-w-2xl">
                            <form class="h-full divide-y divide-gray-200 flex flex-col bg-white shadow-xl"
                                  @submit.prevent="submit">
                                <div class="flex-1 h-0 overflow-y-auto">
                                    <div class="py-6 px-4 bg-dark-pitch-purple sm:px-6">
                                        <div class="flex items-center justify-between">
                                            <DialogTitle class="text-lg text-white" v-if="form.id">
                                                Update Supplier Invoice
                                            </DialogTitle>
                                            <DialogTitle class="text-lg text-white" v-else>
                                                Create Supplier Invoice
                                            </DialogTitle>
                                            <div class="ml-3 h-7 flex items-center">
                                                <button type="button"
                                                        class="bg-dark-pitch-purple rounded-md text-indigo-200 hover:text-white focus:outline-none focus:ring-2 focus:ring-white"
                                                        @click="close()">
                                                    <span class="sr-only">Close panel</span>
                                                    <XIcon class="h-6 w-6" aria-hidden="true"/>
                                                </button>
                                            </div>
                                        </div>
                                        <div class="mt-1">
                                            <p class="text-sm text-indigo-300">
                                                Get started by filling in the information below to create a new
                                                supplier invoice.
                                            </p>
                                        </div>
                                    </div>
                                    <SlideOutErrors :show="showErrors === true"/>
                                    <div class="flex-1 flex flex-col justify-between">
                                        <div class="px-4 divide-y divide-gray-200 sm:px-6">
                                            <div class="mt-6 grid grid-cols-2 gap-4">
                                                <div class="col-span-2">
                                                    <h3 class="text-lg leading-6 font-medium text-gray-900">Supplier
                                                        Information</h3>
                                                </div>
                                                <div class="col-span-2">
                                                    <label for="supplier"
                                                           class="block text-sm text-gray-900 required">
                                                        Supplier
                                                    </label>
                                                    <div class="mt-1">
                                                        <!--<select id="supplier" v-model="form.organisation_id"
                                                                :class="{'border-red-500': form.errors.organisation_id}"
                                                                class="mt-1 block w-full bg-white border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-gray-900 focus:border-gray-900 sm:text-sm">
                                                            <option value selected v-html="'Select a supplier'"></option>
                                                            <option v-for="(supplier,index) in suppliers"
                                                                    v-html="supplier.name" :value="supplier.id"></option>
                                                        </select>-->
                                                        <vue-select v-model="form.organisation_id" label="name" :options="suppliers" :reduce="suppliers => suppliers.id"></vue-select>
                                                    </div>
                                                </div>
                                                <div>
                                                    <label for="recevied_at"
                                                           class="block text-sm text-gray-900 required">
                                                        Received Date <span v-if="formattedReceivedDate">({{ formattedReceivedDate }})</span>
                                                    </label>
                                                    <div class="mt-1">
                                                        <input type="date" v-model="form.received_at" id="received_at"
                                                               class="block w-full shadow-sm sm:text-sm focus:ring-indigo-500 focus:border-light-pitch-purple border-gray-300 rounded-md"
                                                               :class="{'border-red-500': form.errors.received_at}"
                                                        />
                                                    </div>
                                                </div>

                                                <div>
                                                    <label for="invoice_number"
                                                           class="block text-sm text-gray-900 required">
                                                        Invoice Number
                                                    </label>
                                                    <div class="mt-1">
                                                        <input type="text" id="invoice_number" v-model="form.invoice_number"
                                                               class="block w-full shadow-sm sm:text-sm focus:ring-indigo-500 focus:border-light-pitch-purple border-gray-300 rounded-md"
                                                               :class="{'border-red-500': form.errors.invoice_number}"
                                                        />
                                                    </div>
                                                </div>

                                                <div>
                                                    <label for="invoice_currency"
                                                           class="block text-sm text-gray-900 required">
                                                        Invoice Currency
                                                    </label>
                                                    <div class="mt-1">
                                                        <select id="invoice_currency" v-model="form.currency_id"
                                                                :class="{'border-red-500': form.errors.currency_id}"
                                                                class="mt-1 block w-full bg-white border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-gray-900 focus:border-gray-900 sm:text-sm">
                                                            <option value selected
                                                                    v-html="'Select a currency'"></option>
                                                            <option v-for="(currency,index) in currencies"
                                                                    v-html="currency.symbol + ' - ' + currency.name"
                                                                    :value="currency.id"></option>
                                                        </select>
                                                    </div>
                                                </div>

                                                <div>
                                                    <label for="invoice_amount"
                                                           class="block text-sm text-gray-900 required">
                                                        Total Invoice Amount
                                                    </label>
                                                    <div class="mt-1">
                                                        <input type="text" id="invoice_amount" v-model="form.amount"
                                                               class="block w-full shadow-sm sm:text-sm focus:ring-indigo-500 focus:border-light-pitch-purple border-gray-300 rounded-md"
                                                               :class="{'border-red-500': form.errors.amount}"
                                                        />
                                                    </div>
                                                </div>

                                                <div>
                                                    <label for="invoice_gbp_amount"
                                                           class="block text-sm text-gray-900 required">
                                                        Total {{ this.fixture.primary_trading_details?.currency?.code ?? 'GBP' }} Amount
                                                    </label>
                                                    <div class="mt-1">
                                                        <input type="text" id="invoice_gbp_amount" v-model="form.gbp_amount"
                                                               class="block w-full shadow-sm sm:text-sm focus:ring-indigo-500 focus:border-light-pitch-purple border-gray-300 rounded-md"
                                                               :class="{'border-red-500': form.errors.gbp_amount}"
                                                        />
                                                    </div>
                                                </div>

                                                <div>
                                                    <label for="gbp_amount_to_current_fixture"
                                                           class="block text-sm text-gray-900 required">
                                                        {{ this.fixture.primary_trading_details?.currency?.code ?? 'GBP' }} Amount Assigned To Current Fixture
                                                    </label>
                                                    <div class="mt-1">
                                                        <input type="text" id="gbp_amount_to_current_fixture" v-model="form.gbp_amount_to_current_fixture"
                                                               class="block w-full shadow-sm sm:text-sm focus:ring-indigo-500 focus:border-light-pitch-purple border-gray-300 rounded-md"
                                                               :class="{'border-red-500': form.errors.gbp_amount_to_current_fixture}"
                                                        />
                                                    </div>
                                                </div>

                                                <div>
                                                    <label for="disable_email"
                                                           class="block text-sm text-gray-900">
                                                        Disable Email to Finance
                                                    </label>
                                                    <div class="mt-1">
                                                        <input type="checkbox" id="disable_email" v-model="form.disable_email"
                                                            class="focus:ring-indigo-500 h-4 w-4 text-pitch-purple border-gray-300 rounded"
                                                            :class="{'border-red-500': form.errors.disable_email}"
                                                            true-value="1" false-value="0" value="0"
                                                        />
                                                    </div>
                                                </div>

                                                <div>
                                                    <label for="proforma_invoice"
                                                           class="block text-sm text-gray-900 required">
                                                        Is this a Proforma Invoice?
                                                    </label>
                                                    <div class="mt-1">
                                                        <select id="proforma_invoice" v-model="form.proforma_invoice"
                                                                :class="{'border-red-500': form.errors.proforma_invoice}"
                                                                class="mt-1 block w-full bg-white border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-gray-900 focus:border-gray-900 sm:text-sm">
                                                            <option value selected></option>
                                                            <option value="proforma">Proforma</option>
                                                            <option value="vat">VAT Invoice Uploaded</option>
                                                            <option value="zero_vat">Zero VAT</option>
                                                        </select>
                                                    </div>
                                                </div>

                                                <div class="col-span-2">
                                                    <label for="expense_id"
                                                           class="block text-sm text-gray-900">
                                                        Linked Expense (if selected finance will be notified)
                                                    </label>
                                                    <div class="mt-1">
                                                        <select id="invoice_currency" v-model="form.expense_id"
                                                                :class="{'border-red-500': form.errors.expense_id}"
                                                                class="mt-1 block w-full bg-white border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-gray-900 focus:border-gray-900 sm:text-sm">
                                                            <option value selected
                                                                    v-html="'Select an expense'"></option>
                                                            <option v-for="(expense,index) in expenses"
                                                                    v-html="expense.user.name + ' - ' + expense.currency.symbol + expense.amount + (expense.currency.code !== 'GBP' ? ' (£' + expense.gbp_amount + ')' : '') +  ' - ' + moment(String(expense.paid_at)).format('DD/MM/YYYY') + ' - To: ' + expense.supplier"
                                                                    :value="expense.id"></option>
                                                        </select>
                                                    </div>
                                                </div>
                                                
                                                <div class="col-span-2">
                                                    <label for="notes"
                                                           class="block text-sm text-gray-900">
                                                        Notes
                                                    </label>
                                                    <div class="mt-1">
                                                        <quill-editor content-type="html"
                                                                      v-model:content="form.notes"
                                                                      :class="{'border-red-500': form.errors.notes}"
                                                                      class="min-h-[150px] mt-1 block w-full bg-white border border-gray-300 shadow-sm py-2 px-3"
                                                                      theme="snow"></quill-editor>
                                                    </div>
                                                </div>
                                                <div class="col-span-2">
                                                    <label
                                                           class="block text-sm text-gray-900">
                                                        Attach Invoice
                                                    </label>
                                                    <div class="mt-1">
                                                        <dd class="my-2 text-sm text-gray-900" v-if="form.invoices.length > 0">
                                                            <ul role="list" class="border border-gray-200 rounded-md divide-y divide-gray-200">
                                                                <li class="pl-3 pr-4 py-3 flex items-center justify-between text-sm" v-for="(invoice,index) in form.invoices">
                                                                    <div class="w-0 flex-1 flex items-center">
                                                                        <PaperClipIcon class="flex-shrink-0 h-5 w-5 text-gray-400" aria-hidden="true" />
                                                                        <span class="ml-2 flex-1 w-0 truncate"> {{ invoice }} </span>
                                                                    </div>
                                                                    <div class="ml-4 flex-shrink-0">
                                                                        <a :href="route('frontend.fixture.supplier-invoice.invoice.download', [form.fixture_id, form.id, invoice])" class="font-medium text-pitch-purple hover:text-light-pitch-purple"> <DownloadIcon class="w-4 h-4" /> </a>
                                                                    </div>
                                                                </li>
                                                            </ul>
                                                        </dd>
                                                        <label class="w-full mb-4 flex flex-col items-center px-4 py-6 bg-white text-blue rounded-lg tracking-wide uppercase border border-blue cursor-pointer">
                                                            <svg class="w-8 h-8" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                                                <path d="M16.88 9.1A4 4 0 0 1 16 17H5a5 5 0 0 1-1-9.9V7a3 3 0 0 1 4.52-2.59A4.98 4.98 0 0 1 17 8c0 .38-.04.74-.12 1.1zM11 11h3l-4-4-4 4h3v3h2v-3z" />
                                                            </svg>
                                                            <span v-if="form.file_uploads.length  === 0" class="mt-2 text-base leading-normal">Select a file</span>
                                                            <span v-else>{{ form.file_uploads.length }} file<span v-if="form.file_uploads.length > 1">s</span> selected for upload</span>
                                                            <input type='file' class="hidden" multiple @change="prepareFileUpload($event)" />
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div class="flex-shrink-0 px-4 py-4 flex justify-end">
                                    <button type="button"
                                            class="bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                            @click="close()">
                                        Close
                                    </button>
                                    <button :disabled="form.processing || !form.isDirty" type="submit"
                                            class=" ml-4 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm rounded-md text-white bg-pitch-purple hover:bg-dark-pitch-purple focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:bg-gray-200">
                                        <span v-if="updating === true">Update</span>
                                        <span v-else>Save</span>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </TransitionChild>
                </div>
            </div>
        </Dialog>
    </TransitionRoot>
</template>
<script>
import {ref, reactive} from 'vue'
import {Dialog, DialogOverlay, DialogTitle, TransitionChild, TransitionRoot} from '@headlessui/vue'
import {XIcon} from '@heroicons/vue/outline'
import {LinkIcon, PlusSmIcon, QuestionMarkCircleIcon, ExclamationCircleIcon, UploadIcon, PaperClipIcon, DownloadIcon} from '@heroicons/vue/solid'
import {useForm, usePage} from '@inertiajs/vue3'
import { router } from '@inertiajs/vue3'
import SlideOutErrors from "@/Components/SlideOutErrors";
import {mapState} from "vuex";
import {emitter} from "@/eventHub";
import moment from "moment/moment";
import VueSelect from "vue-select";

export default {
    components: {
        SlideOutErrors,
        Dialog,
        DialogOverlay,
        DialogTitle,
        TransitionChild,
        TransitionRoot,
        LinkIcon,
        PlusSmIcon,
        QuestionMarkCircleIcon,
        ExclamationCircleIcon,
        XIcon,
        UploadIcon,
        PaperClipIcon,
        DownloadIcon,
        VueSelect
    },
    computed: {
        ...mapState({
            suppliers: state => state.supplierinvoice.suppliers ?? null,
            expenses: state => state.supplierinvoice.expenses ?? null,
            currencies: state => state.supplierinvoice.currencies ?? null,
        }),
        /**
         * Extracts the currency ID of GBP
         */
         gbpCurrencyId () {
            var defaultCurrency = Object.values(this.currencies.filter(c => c.code == 'GBP'));

            return defaultCurrency.length ? defaultCurrency[0].id : 0;
        },
        formattedReceivedDate() {
            if (this.form.received_at) {
                return moment(this.form.received_at).format('DD MMM YYYY');
            }
            return '';
        },
    },
    watch: {
        'form.gbp_amount': function(amount) {
            if (amount !== 0 && this.updating == false) {
                this.form.gbp_amount_to_current_fixture = amount;
            }
        },
    },
    setup(prop, context) {

        const show = ref(false)

        const showErrors = ref(false)

        const updating = false;

        const fixture = usePage().props.fixture;

        const form = useForm({
            id: null,
            fixture_id: null,
            organisation_id: "",
            received_at: null,
            invoice_number: null,
            amount: null,
            currency_id: fixture?.primary_trading_details?.currency_id ?? null,
            expense_id: "",
            gbp_amount: null,
            notes: "",
            invoices: [],
            file_uploads: [],
            disable_email: '0',
            gbp_amount_to_current_fixture: null,
            proforma_invoice: null
        })

        function submit() {
            if (this.updating) {
                this.form.post(route('frontend.fixture.supplier-invoice.invoice.update', [usePage().props.fixture.id, this.form.id]), {
                    onSuccess: page => {
                        this.show = false;
                        this.showErrors = false;
                        this.form.reset();
                    },
                    onError: errors => {
                        this.showErrors = true;
                    }
                });
            } else {
                this.form.post(route('frontend.fixture.supplier-invoice.store', [usePage().props.fixture.id]), {
                    onSuccess: page => {
                        this.show = false;
                        this.showErrors = false;
                        this.form.reset();
                    },
                    onError: errors => {
                        this.showErrors = true;
                    }
                });
            }
        }

        function close() {
            this.form.reset();
            this.form.clearErrors();
            this.updating = false;
            this.show = false;
        }

        function open() {
            this.$store.dispatch('supplierinvoice/getData', {
                fixture_id: fixture.id
            });
            if (typeof fixture !== 'undefined') {
                this.form.fixture_id = fixture.id
            }
            if (!this.updating) {
                this.form.currency_id = this.fixture?.primary_trading_details?.currency_id ?? this.gbpCurrencyId ?? null;
            }
            this.form.clearErrors();
            this.show = true;
        }

        const emitter = emitter;

        return {
            show,
            form,
            submit,
            updating,
            close,
            open,
            showErrors,
            emitter,
            fixture
        }
    },
    mounted() {
        emitter.on('openSupplierInvoiceSlideout', () => {
            this.open();
        });
        
        emitter.on('editSupplierInvoiceSlideout', (supplier_invoice) => {
            this.updating = true;
            this.form.id = supplier_invoice.id;
            this.form.organisation_id = supplier_invoice.organisation_id
            this.form.received_at = supplier_invoice.received_at
            this.form.amount = supplier_invoice.amount
            this.form.gbp_amount = supplier_invoice.gbp_amount
            this.form.currency_id = supplier_invoice.currency_id
            this.form.expense_id = supplier_invoice.expense_id
            this.form.invoices = supplier_invoice.invoices ?? []
            this.form.notes = supplier_invoice.notes
            this.form.invoice_number = supplier_invoice.invoice_number
            this.form.fixture_id = supplier_invoice.fixture_id
            this.form.disable_email = supplier_invoice.disable_email ? '1' : '0'
            this.form.proforma_invoice = supplier_invoice.proforma_invoice
            this.form.gbp_amount_to_current_fixture = supplier_invoice.total_fixture_linked_amount
            this.open();
        })

    },
    methods: {
        prepareFileUpload(event) {
            this.form.file_uploads = event.target.files
        }
    },
    created() {
        this.moment = moment;
    }
}
</script>
